import React from "react";
import classNames from "classnames";
import "./headerColor.sass";
import {Color} from "../../../shared/enums/color";

export interface IHeaderColorProps {
  color: Color;
}

const HeaderColor: React.FC<IHeaderColorProps> = ({color}) => {
  return <div className={classNames("header-color", color)}></div>;
};

export default HeaderColor;
